/* Cart drawer presentation layer. theme.js owns the cart data and rewrites
   [data-cart-items]; this watches its output and reshapes it: price above the
   quantity box, progress mirrored onto a ring (a filled check once free
   shipping is unlocked), pre-discount total struck through on the subtotal,
   and upsell cards hidden when already in the cart. */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var items   = drawer.querySelector('[data-cart-items]');
  var bar     = drawer.querySelector('[data-cart-ship-bar]');
  var ring    = drawer.querySelector('[data-cart-ship-ring]');
  var shipBox = drawer.querySelector('[data-cart-ship]');
  var shipTxt = drawer.querySelector('[data-cart-ship-text]');
  var upsell  = drawer.querySelector('[data-cart-upsell]');
  var wasEl   = drawer.querySelector('[data-cart-was]');
  var salePct = parseInt(drawer.getAttribute('data-sale-pct') || '0', 10) || 0;
  var CIRC    = 97.39;

  /* Handles of full-price pieces (The Cashmere Edit). They never carry the
     sitewide strike-through, in the rows or in the subtotal. */
  var fullPrice = {};
  (drawer.getAttribute('data-full-price') || '').split(',').forEach(function (h) {
    h = h.trim();
    if (h) fullPrice[h] = true;
  });

  function handleOf(href) {
    if (!href) return '';
    var s = String(href);
    var i = s.indexOf('/products/');
    if (i === -1) return '';
    var rest = s.slice(i + 10);
    var cut = rest.length;
    var stops = ['?', '#', '/'];
    for (var k = 0; k < stops.length; k++) {
      var p = rest.indexOf(stops[k]);
      if (p !== -1 && p < cut) cut = p;
    }
    return rest.slice(0, cut);
  }

  function reflowItems() {
    if (!items) return;
    var rows = items.querySelectorAll('.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var info = row.querySelector('.cart-item__info');
      var prices = row.querySelector('.cart-item__prices');
      var controls = row.querySelector('.cart-item__controls');
      if (!info || !prices) continue;
      if (prices.parentNode === info && (!controls || prices.nextElementSibling === controls)) continue;
      if (controls) info.insertBefore(prices, controls);
      else info.appendChild(prices);
    }
  }

  function stripFullPrice() {
    if (!items) return;
    var rows = items.querySelectorAll('.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var t = rows[i].querySelector('.cart-item__title');
      if (!t || !fullPrice[handleOf(t.getAttribute('href'))]) continue;
      var w = rows[i].querySelector('.cart-item__was');
      if (w && w.parentNode) w.parentNode.removeChild(w);
    }
  }

  function syncShip() {
    var pct = bar ? (parseFloat(String(bar.style.width || '0')) || 0) : 0;
    if (pct > 100) pct = 100;
    if (ring) ring.style.strokeDashoffset = String(CIRC - (CIRC * pct) / 100);
    if (shipBox) shipBox.classList.toggle('is-done', pct >= 100);

    if (!shipTxt) return;
    var strong = shipTxt.querySelector('strong');
    var want;
    if (strong && strong.textContent.trim()) {
      want = 'You are only <strong>' + strong.textContent.trim() + '</strong> away from free shipping';
    } else if (pct >= 100) {
      want = '<span class="cart-ship__done">Your order ships free</span>';
    } else {
      return;
    }
    if (shipTxt.innerHTML !== want) shipTxt.innerHTML = want;
  }

  function listPrice(price, compare) {
    var list = price;
    if (compare && compare > list) list = compare;
    if (salePct > 0 && price > 0) {
      var keep = 100 - salePct;
      var whole = Math.floor(Math.floor(price * 100 / keep) / 100);
      var derived = whole * 100 + 95;
      if (derived <= price) derived = (whole + 1) * 100 + 95;
      if (derived > list) list = derived;
    }
    return list;
  }
  function money(c) {
    var s = (c / 100).toFixed(2);
    var parts = s.split('.');
    var n = parts[0], out = '';
    while (n.length > 3) { out = ',' + n.slice(-3) + out; n = n.slice(0, -3); }
    return '$' + n + out + '.' + parts[1];
  }
  var wasTimer;
  function syncWas() {
    if (!wasEl || !window.fetch) return;
    clearTimeout(wasTimer);
    wasTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var was = 0;
          (c.items || []).forEach(function (it) {
            var unit = it.original_price || it.price;
            if (fullPrice[it.handle]) {
              if (it.compare_at_price && it.compare_at_price > unit) unit = it.compare_at_price;
              was += unit * it.quantity;
            } else {
              was += listPrice(unit, it.compare_at_price) * it.quantity;
            }
          });
          var sub = drawer.querySelector('[data-cart-subtotal]');
          var now = money(c.total_price);
          if (sub && sub.textContent !== now) sub.textContent = now;
          var w = money(was);
          if (was > c.total_price) {
            if (wasEl.textContent !== w) wasEl.textContent = w;
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        })
        .catch(function () {});
    }, 200);
  }

  function syncUpsell() {
    if (!upsell || !items) return;
    var inCart = {};
    var links = items.querySelectorAll('.cart-item__title[href]');
    for (var i = 0; i < links.length; i++) {
      var h = handleOf(links[i].getAttribute('href'));
      if (h) inCart[h] = true;
    }
    var cards = upsell.querySelectorAll('.cart-up__card');
    var shown = 0;
    for (var j = 0; j < cards.length; j++) {
      var card = cards[j];
      var t = card.querySelector('.cart-up__title');
      var ch = handleOf(t && t.getAttribute('href'));
      var hide = !!(ch && inCart[ch]);
      card.hidden = hide;
      if (!hide) shown++;
    }
    var hasItems = items.querySelector('.cart-item') !== null;
    upsell.hidden = !hasItems || shown === 0;
  }

  function syncAll() { reflowItems(); stripFullPrice(); syncUpsell(); syncWas(); }

  if (window.MutationObserver) {
    if (items) new MutationObserver(syncAll).observe(items, { childList: true, subtree: true });
    if (bar) new MutationObserver(syncShip).observe(bar, { attributes: true, attributeFilter: ['style'] });
    if (shipTxt) new MutationObserver(syncShip).observe(shipTxt, { childList: true, subtree: true, characterData: true });
  }

  drawer.addEventListener('click', function (e) {
    var open = e.target.closest('[data-up-open]');
    if (open) {
      e.preventDefault();
      var card = open.closest('.cart-up__card');
      var sizes = card && card.querySelector('[data-up-sizes]');
      if (sizes) {
        sizes.hidden = !sizes.hidden;
        open.textContent = sizes.hidden ? 'Add to cart' : 'Pick a size';
      }
      return;
    }
    var add = e.target.closest('[data-up-add]');
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-up-add');
    if (!id) return;
    var card2 = add.closest('.cart-up__card');
    var btn = card2 && card2.querySelector('.cart-up__btn');
    if (btn) btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { alert(res.description || res.message); return; }
        var sizes2 = card2 && card2.querySelector('[data-up-sizes]');
        if (sizes2) sizes2.hidden = true;
        if (window.theme && window.theme.refreshCart) return window.theme.refreshCart();
      })
      .catch(function () {})
      .finally(function () {
        if (btn) { btn.classList.remove('is-busy'); btn.textContent = 'Add to cart'; }
      });
  });

  syncAll();
  syncShip();
  document.addEventListener('DOMContentLoaded', function () { syncAll(); syncShip(); });
})();


/* Free-shipping line, always taken from the live cart. Before this, the line
   was only rewritten when theme.js re-rendered the drawer, so a page restored
   from the back/forward cache, a cart changed in another tab, or the drawer
   opened from the header icon could still say "You are only $X away" after
   the cart had passed the free-shipping threshold. */
(function () {
  'use strict';
  var drawer = document.getElementById('CartDrawer');
  if (!drawer || !window.fetch) return;
  var FREE = parseInt(drawer.getAttribute('data-free-ship') || '0', 10) || 0;
  var box = drawer.querySelector('[data-cart-ship]');
  var txt = drawer.querySelector('[data-cart-ship-text]');
  var bar = drawer.querySelector('[data-cart-ship-bar]');
  var items = drawer.querySelector('[data-cart-items]');
  if (!FREE || !txt) return;

  function money(c) {
    var s = (c / 100).toFixed(2).split('.');
    return '$' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1];
  }

  var timer;
  function check() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c) return;
          if (!c.item_count) { if (box) box.hidden = true; return; }
          var left = FREE - c.total_price;
          var pct = Math.min(100, Math.round((c.total_price / FREE) * 100));
          if (bar) bar.style.width = pct + '%';
          if (box) { box.hidden = false; box.classList.toggle('is-done', left <= 0); }
          var want = left > 0
            ? 'You are only <strong>' + money(left) + '</strong> away from free shipping'
            : '<span class="cart-ship__done">Your order ships free</span>';
          if (txt.innerHTML !== want) txt.innerHTML = want;
        })
        .catch(function () {});
    }, 150);
  }

  function refresh() {
    if (window.theme && window.theme.refreshCart) {
      window.theme.refreshCart().then(check, check);
    } else {
      check();
    }
  }

  if (items && window.MutationObserver) {
    new MutationObserver(check).observe(items, { childList: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-drawer-open]');
    if (t && t.getAttribute('data-drawer-open') === '#CartDrawer') refresh();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });
  check();
})();
